import { memo, useContext, useMemo } from "react";
import { Handle, Position, useStore } from "reactflow";
import "./CustomNode.scss";
import { generalNodes, farmGateNodes, processGateNodes } from "../../../config/drawingConstants";
import { DrawingContext } from "../DrawingTool";
import IngredientIcon from "../../../assets/mappingIcon/IngredientIcon";
import { iconMap } from "../../../utils/mapping";
import { isEmpty } from "lodash";

const connectionNodeIdSelector = (state: any) => state.connectionNodeId;
interface CustomNodeProps {
  id: string;
  data: any;
  isConnectable: boolean;
  selected: boolean;
}

const sourceStyle = { zIndex: 1, backgroundColor: "#3FBE5A" };

export default memo((props: CustomNodeProps) => {
  const drawingContext = useContext(DrawingContext);
  const { data, id } = props;
  const nodeTypes = [...generalNodes, ...farmGateNodes, ...processGateNodes];
  const connectionNodeId = useStore(connectionNodeIdSelector);
  const isConnecting = !!connectionNodeId;
  const imageName = nodeTypes.find(n => n.id === data.icon)?.image || "";

  const isMissingDataNode = useMemo(() => {
    const node = drawingContext?.missingNodeIds?.find((missingId: string) => id === missingId);
    return node !== undefined;
  }, [drawingContext?.missingNodeIds]);

  const loadMappingIcon = (iconName: string): JSX.Element => {
    const SelectedIcon = iconMap[iconName] || IngredientIcon;
    return <SelectedIcon />;
  };

  const nodeDescription = useMemo(() => {
    const withoutSpaceDescription = data.description?.replaceAll(" ", "");
    return !isEmpty(withoutSpaceDescription) ? data.description : "Add Details";
  }, [data.description]);

  return (
    <>
      <div className={`node-item ${isMissingDataNode ? "error-node-border" : ""}`}>
        <div className="node-header">
          <span>{data.label}</span>
        </div>

        {!isConnecting && (
          <Handle
            className="custom-handle"
            position={Position.Left}
            type="source"
            style={sourceStyle}
          />
        )}
        <Handle
          className="custom-handle"
          position={Position.Left}
          type="target"
          style={{ backgroundColor: "#3FBE5A" }}
        />
        <div className="node-item-image">{loadMappingIcon(imageName)}</div>
        <div
          className="node-footer"
          onClick={() => {
            drawingContext.setNodeItem(props.id);
          }}
        >
          <span>{nodeDescription}</span>
        </div>
      </div>
    </>
  );
});
